export default {
  data () {
    return {
      frame: {
        modal: { type: String, default: null }
      }
    }
  }
}